import * as actionType from "./Action_Type";
import createBrowserHistory from "history/createBrowserHistory";
import { URL_EMAIL_CONFIRM } from "../Utils/Strings/URL.js";
import { refreshList, requestList } from "./Action_Utils.js";
import * as PAGESSWITCH from "../Utils/PagesSwitch.js";
import * as ROUTE       from "../Utils/Strings/Route";

let history = createBrowserHistory();

export const confirmEmail_Request = () =>({
    type   : actionType.SERVICE_CONFIRM_EMAIL_REQUEST,
});

export const confirmEmail_Success = () =>({
    type   : actionType.SERVICE_CONFIRM_EMAIL_SUCCESS,
});

export const confirmEmail_Error = (msgErr) =>({
    type   : actionType.SERVICE_CONFIRM_EMAIL_ERROR,
    error  : msgErr 
});

export function confirmEmail(Token) {
  let config = {
        method  : 'GET',
        headers : { 'Content-Type': 'application/json' }
    };
    return dispatch => {
      dispatch(confirmEmail_Request());

      return fetch( URL_EMAIL_CONFIRM+"?Token="+Token, config)
        .then(response =>
          response.json().then(result => ({ result, response }))
        )
        .then(({ result, response }) => {
            if (!response.ok)
                return Promise.reject(result);
            if(result.Code !== 200)
                return Promise.reject(result);
            if(result.Code === 200 && !result.Data )
                return Promise.reject(result);
            if(result.Code === 200 && result.Data ){
                dispatch(confirmEmail_Success());
            }
        })
        .catch(err => {
            console.error(err.error_description);
            dispatch(confirmEmail_Error(err.error_description || err.Message || "General Error"));
          }
        );
    };
}

const goToLoginReq = () => ({
    type : actionType.SERVICE_CONFIRM_EMAIL_GOTOLOGIN
});

export function goToLogin(){
    return dispatch => {
        dispatch(goToLoginReq());
        setTimeout(()=>{
            PAGESSWITCH.gotoPageWithParams(ROUTE.Root)
        }, 500);
    }
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_ConfermaEmail.js